import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IStandort } from 'fa-kt.types';
import { BehaviorSubject } from 'rxjs';
import { StandortsService } from '../service';

@Component({
  selector: 'fa-kt-standorts-list',
  templateUrl: './standorts-list.component.html',
  styleUrls: ['./standorts-list.component.css'],
})
export class StandortsListComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Output() select: EventEmitter<IStandort> = new EventEmitter<IStandort>();

  constructor(public standorts: StandortsService) {}

  ngOnDestroy() {}
}
